import { useQuery } from "@tanstack/react-query";
import useEmblaCarousel from "embla-carousel-react";
import React, { useCallback, useEffect, useState } from "react";
import { getBanners, getSystemValues } from "../api/services";

const HomePage = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });
  const [telegramLink, setTelegramLink] = useState("");
  const [whatsappLink, setWhatsappLink] = useState("");

  const bannersQuery = useQuery({
    queryKey: ["banners"],
    queryFn: getBanners,
  });

  const systemValuesQuery = useQuery({
    queryKey: ["systemValues"],
    queryFn: getSystemValues,
  });

  useEffect(() => {
    if (systemValuesQuery.isSuccess && systemValuesQuery.data) {
      const systemValues = systemValuesQuery.data;

      if (systemValues.telegram) {
        setTelegramLink(systemValues.telegram);
      }

      if (systemValues.whatsapp) {
        const cleanNumber = systemValues.whatsapp.replace(/\D/g, "");
        setWhatsappLink(`https://wa.me/${cleanNumber}`);
      }
    }
  }, [systemValuesQuery.data, systemValuesQuery.isSuccess]);

  const autoScroll = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  useEffect(() => {
    const intervalId = setInterval(autoScroll, 3000);
    return () => clearInterval(intervalId);
  }, [autoScroll]);

  const bannerImages =
    bannersQuery.isSuccess && bannersQuery.data && bannersQuery.data.length > 0
      ? bannersQuery.data.map((banner) => banner.image)
      : [
          "https://images.unsplash.com/photo-1531415074968-036ba1b575da?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1595434091143-b375ced5fe5c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        ];

  const handleMatchReportClick = () => {
    window.open(whatsappLink || "https://wa.me/", "_blank");
  };

  const handleJoinTelegramClick = () => {
    window.open(`https://t.me/${telegramLink}`, "_blank");
  };

  if (bannersQuery.isLoading || systemValuesQuery.isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        Loading...
      </div>
    );
  }

  return (
    <div className="max-w-[800px] mx-auto h-screen flex flex-col gap-5 items-center">
      <div className="overflow-hidden w-full " ref={emblaRef}>
        <div className="flex">
          {bannerImages.map((image, index) => (
            <div className="flex-[0_0_100%] min-w-0" key={index}>
              <img
                src={image}
                alt={`Cricket Match ${index + 1}`}
                className="w-full h-auto block aspect-video object-cover"
              />
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-4 w-full px-5 flex-1 ">
        <div className="flex flex-col gap-4 w-full">
          <button
            className="py-4 px-5 flex-col flex gap-2 items-center justify-center rounded text-base font-bold cursor-pointer transition-all duration-300 text-white bg-red-600"
            onClick={handleMatchReportClick}
          >
            <img src="/whatsapp.png" alt="whatsapp" className="h-10" />
            Check Today's Match Report
          </button>
          <button
            className="py-4 px-5 flex-col flex gap-2 items-center justify-center rounded text-base font-bold cursor-pointer transition-all duration-300 text-white bg-red-600"
            onClick={handleJoinTelegramClick}
          >
            <img src="/telegram.png" alt="telegram" className="h-10" />
            Telegram
          </button>
        </div>
      </div>
      <p className="text-center text-sm text-gray-500 p-5 font-semibold">
        JOIN TELEGRAM CHANNEL AND CHECK EVERY CRICKET MATCH REPORT WITH 97%
        ACCURACY
      </p>
    </div>
  );
};

export default HomePage;
